import { isNil } from "lodash";
import { publish } from "../01-helpers/event-manager";

export default class Request {

    constructor(owner) {
        this.owner = owner;
    }

    get(url, event_name_success, event_name_error) {
        if (isNil(event_name_success) || isNil(event_name_error)) {
            throw "Missing event names";
        }


        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.open("GET", url);
        xhr.onload = function () {
            if (xhr.status === 200) {
                publish(event_name_success, { response: xhr.response });
            }
            else {
                publish(event_name_error, { status: xhr.status });
            }
        };
        xhr.send();
    }

    _throwError(message) {
        throw message;
    }
}